import { SideBarMenuUI } from "components/SideBar/SideBarMenu";
import { AuthContext } from "hooks/authProvider/authProvider";
import { cn } from "lib/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { type FC, type HTMLAttributes, useContext } from "react";
import { useLocation } from "react-router-dom";

export type SideBarUIProps = HTMLAttributes<HTMLDivElement> & {
  isSidebarOpen?: boolean;
  onToggleSidebar?: () => void;
};

export const SideBarUI: FC<SideBarUIProps> = ({
  className,
  isSidebarOpen = false,
  onToggleSidebar,
  ...rest
}) => {
  const { currentUser, isLoadingUser } = useContext(AuthContext);
  const location = useLocation();

  return (
    <div
      className={cn("flex overflow-visible relative h-full", className)}
      {...rest}
    >
      <div className="hidden md:flex md:shrink-0 w-full h-full">
        <div className="flex flex-col w-full h-full transition-all duration-300">
          <div className="flex flex-col h-full py-4 bg-gradient-to-r from-sidebar-left to-sidebar-right border-r border-white/10 relative">
            <SideBarMenuUI
              currentUser={isLoadingUser ? null : currentUser}
              currentPath={location.pathname}
              isSidebarOpen={isSidebarOpen}
            />
          </div>
        </div>
      </div>
      {/* 開閉ボタン（常に右端に表示、上部に配置）*/}
      {onToggleSidebar && (
        <button
          type="button"
          onClick={onToggleSidebar}
          className={cn(
            "absolute top-6 right-0 translate-x-1/2",
            "bg-gradient-to-r from-sidebar-left to-sidebar-right",
            "text-white hover:bg-white/25",
            "h-7 w-7 rounded-full flex items-center justify-center",
            "border-2 border-white/30 shadow-lg",
            "backdrop-blur-sm",
            "z-10 transition-all duration-300 ease-out",
            "hover:scale-110 hover:shadow-xl",
            "active:scale-95",
            "hidden md:flex",
          )}
          aria-label={isSidebarOpen ? "サイドナビを閉じる" : "サイドナビを開く"}
        >
          {isSidebarOpen ? (
            <ChevronLeft className="h-4 w-4 transition-transform duration-300" />
          ) : (
            <ChevronRight className="h-4 w-4 transition-transform duration-300" />
          )}
        </button>
      )}
    </div>
  );
};
